import { Passenger } from "../passengers/types";
import {Reservations} from "./types";

export const getPassengersFromReservations = (reservations: Reservations) => {
    let passengers: Passenger[] = []
    reservations.forEach((reservation) =>{
        passengers.push(reservation.passenger);
    })
    return passengers
}